import {
  createShippingOption as publicCreateShippingOption,
  getShippingOption as publicGetShippingOption,
  updateShippingOption as publicUpdateShippingOption,
  deleteShippingOption as publicDeleteShippingOption,
  queryShippingOptions as publicQueryShippingOptions,
  updateExtendedFields as publicUpdateExtendedFields,
} from './ecom-v1-shipping-option-shipping-options.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { onShippingOptionCreated as publicOnShippingOptionCreated } from './ecom-v1-shipping-option-shipping-options.public.js';
import { onShippingOptionDeleted as publicOnShippingOptionDeleted } from './ecom-v1-shipping-option-shipping-options.public.js';
import { onShippingOptionUpdated as publicOnShippingOptionUpdated } from './ecom-v1-shipping-option-shipping-options.public.js';

export const createShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicCreateShippingOption> &
    typeof publicCreateShippingOption
> = /*#__PURE__*/ createRESTModule(publicCreateShippingOption);
export const getShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicGetShippingOption> &
    typeof publicGetShippingOption
> = /*#__PURE__*/ createRESTModule(publicGetShippingOption);
export const updateShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicUpdateShippingOption> &
    typeof publicUpdateShippingOption
> = /*#__PURE__*/ createRESTModule(publicUpdateShippingOption);
export const deleteShippingOption: MaybeContext<
  BuildRESTFunction<typeof publicDeleteShippingOption> &
    typeof publicDeleteShippingOption
> = /*#__PURE__*/ createRESTModule(publicDeleteShippingOption);
export const queryShippingOptions: MaybeContext<
  BuildRESTFunction<typeof publicQueryShippingOptions> &
    typeof publicQueryShippingOptions
> = /*#__PURE__*/ createRESTModule(publicQueryShippingOptions);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
/** */
export const onShippingOptionCreated: ReturnType<
  typeof createEventModule<typeof publicOnShippingOptionCreated>
> = createEventModule(publicOnShippingOptionCreated);
/** */
export const onShippingOptionDeleted: ReturnType<
  typeof createEventModule<typeof publicOnShippingOptionDeleted>
> = createEventModule(publicOnShippingOptionDeleted);
/** */
export const onShippingOptionUpdated: ReturnType<
  typeof createEventModule<typeof publicOnShippingOptionUpdated>
> = createEventModule(publicOnShippingOptionUpdated);

export {
  ConditionType,
  LogicalOperator,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
export {
  ShippingOption,
  ConditionalRates,
  Condition,
  ExtendedFields,
  CreateShippingOptionRequest,
  CreateShippingOptionResponse,
  GetShippingOptionRequest,
  GetShippingOptionResponse,
  UpdateShippingOptionRequest,
  UpdateShippingOptionResponse,
  DeleteShippingOptionRequest,
  DeleteShippingOptionResponse,
  QueryShippingOptionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryShippingOptionsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  ShippingOptionNonNullableFields,
  CreateShippingOptionResponseNonNullableFields,
  GetShippingOptionResponseNonNullableFields,
  UpdateShippingOptionResponseNonNullableFields,
  QueryShippingOptionsResponseNonNullableFields,
  UpdateExtendedFieldsResponseNonNullableFields,
  BaseEventMetadata,
  EventMetadata,
  ShippingOptionCreatedEnvelope,
  ShippingOptionDeletedEnvelope,
  ShippingOptionUpdatedEnvelope,
  UpdateShippingOption,
  ShippingOptionsQueryResult,
  ShippingOptionsQueryBuilder,
  UpdateExtendedFieldsOptions,
} from './ecom-v1-shipping-option-shipping-options.universal.js';
